import { render } from "./novembro.vue?vue&type=template&id=7c40c321"
import script from "./novembro.vue?vue&type=script&lang=js"
export * from "./novembro.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__